<template>
  <div class="bblayout">
    <img src="https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/anniversary/carrental-consulting-bg.jpg" alt=""
      class="bg">
  </div>
</template>
<script setup>
</script>
<style lang="scss" scoped>
@import url('@/style/bottombarlayout.scss');
@import url('@/style/simplebtn.scss');

.bblayout {
  overflow: auto;
  background-color: #cccdd1;
}

.bg {
  width: 100%;
}</style>